<template>
 
   <loading-state
      v-if="loading"
      :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
    />
  <superset v-else-if="dashboardAPP" class="column" :supersetId="dashboardAPP.content.url" />
  <div v-else class="column">
    <empty-state :title="$t('DASHBOARD_APPS.NO_DATA')" />
  </div>
 
</template>
<script>

import alertMixin from 'shared/mixins/alertMixin';

import Superset from './Superset.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import DashboardAppsAPI from 'dashboard/api/dashboardApps';
import EmptyState from 'dashboard/components/widgets/EmptyState';

export default {
  components: {
    Superset,
    LoadingState,
    EmptyState,
  },
  mixins: [alertMixin],
  props: {
    slug: String
  },
  data() {
    return {
      loading: true,
      dashboardAPP: null
    };
  },  
  watch: {
    slug: {
      async handler() {
        this.render();
      },
      immediate: true
    }
  },
  methods: {
    async render(){
      this.loading = true;
      this.dashboardAPP = null;
      try{
        const resp = await DashboardAppsAPI.show(this.slug);
        if(resp?.data?.content && resp.data.content.url && resp.data.content.url.trim() != ""){
          this.dashboardAPP = resp.data;
        }
        this.loading = false;
      }catch(error){
        this.loading = false;
        this.showAlert(this.$t('DASHBOARD_APPS.ERROR_FETCH'));
      } 

    }
  }
};
</script>